import { onValue, ref, set } from "firebase/database";
import _ from 'lodash';
import { convertHelpers } from "../../../global/common/convert";
import { getSportsYear } from '../../../global/firestoreData/helpers/years';
import { seasonalUpdateTypes } from "../cnr/reducers/reducerHelpers/seasonalDataHelpers";
import { realtimeDocumentTypes } from "../cnr/reducers/SportsEditMatchReducer";
import { matchCalcs } from "../helpers/match";

const _allowRt = true
const _isDemo = false
const _allowUpdate_local = true

const _matchDateResultsName = _isDemo ? 'matchDayResults_demo' : 'matchDayResults'
const _realtimeResultsName = _isDemo ? 'realtimeResults_demo' : 'realtimeResults'

const rtPath_results = (realtimeDocumentType, pathViews, sportsYear, realtimeMatchKey, uid) => {
  const rtDoc = realtimeDocumentType === realtimeDocumentTypes.matchDay ? _matchDateResultsName : _realtimeResultsName
  const path = 'clients/' + pathViews.clients + '/events/' + pathViews.events + '/' + rtDoc + '/' + sportsYear
  return realtimeMatchKey ? path + '/' + realtimeMatchKey + '/' + uid : path
}

const rtPath_results_noId = (realtimeDocumentType, pathViews, sportsYear, realtimeMatchKey) => {
  const rtDoc = realtimeDocumentType === realtimeDocumentTypes.matchDay ? _matchDateResultsName : _realtimeResultsName
  const path = 'clients/' + pathViews.clients + '/events/' + pathViews.events + '/' + rtDoc + '/' + sportsYear
  return path + '/' + realtimeMatchKey
}

export const realTimeScoring = {
  ammendRealtimeResults: (rtr, gameScoringType) => ammendRealtimeResults(rtr, gameScoringType),
  calcMatchAndUpdateRtDb: (mainRt, sportPermissions, sportDataSettings, match, match_true, pathViews, appUserInfo, latestSeason, tracker) => calcMatchAndUpdateRtDb(mainRt, sportPermissions, sportDataSettings, match, match_true, pathViews, appUserInfo, latestSeason, tracker),
  deleteRealtimeDatabaseScores: (mainRt, realtimeDocumentType, sportPermissions, sportDataSettings, seasonalUpdateType, pathViews, matchKeys, appUserInfo, latestSeason, callback) => deleteRealtimeDatabaseScores(mainRt, realtimeDocumentType, sportPermissions, sportDataSettings, seasonalUpdateType, pathViews, matchKeys, appUserInfo, latestSeason, callback),
  getRealtimeScores: (mainRt, realtimeDocumentType, useRtMatchData, pathViews, latestSeason, callback) => getRealtimeScores(mainRt, realtimeDocumentType, useRtMatchData, pathViews, latestSeason, callback),
  updateRealtimeScoresToDatabase: (mainRt, rtProps) => updateRealtimeScoresToDatabase(mainRt, rtProps),
  updateMatchDayScoresToDatabase: (mainRt, rtProps) => updateMatchDayScoresToDatabase(mainRt, rtProps),
}


/**
 * Updates the scores into the realtime database
 * @param {object} pathViews 
 * @param {object} realtimeMatch 
 * @param {object} results 
 * @param {object} appUserInfo 
 * @param {string} latestSeason 
 * @param {function} callback 
 */
const updateRealtimeScoresToDatabase = async (mainRt, rtProps) => {
  const {
    appUserInfo,
    callback,
    currentUserId,
    latestSeason,
    match_key,
    matchDayUpdates,
    pathViews,
    realtimeDocumentType,
    results,
    seasonalUpdateType,
    sportDataSettings,
    sportPermissions,
    tracker,
  } = rtProps;

  const allowUpdate = sportPermissions.any && sportPermissions[seasonalUpdateType] && _allowRt;
  const { useRtMatchData } = sportDataSettings;
  const { uid, displayName } = appUserInfo ?? {};
  const sportsYear = getSportsYear(latestSeason);

  // Helper function to update database and handle success/failure
  const updateDatabase = async (refString, updateData) => {
    try {
      await set(ref(mainRt, refString), updateData);
      return { success: true };
    } catch (error) {
      console.log('updateRealtimeScoreToDatabase Error', error);
      return { success: false, error };
    }
  };

  if (matchDayUpdates) {
    // Generate promises for each update in `matchDayUpdates`
    const updatePromises = _.map(matchDayUpdates, async (matchDayUpdate, matchKey) => {
      const { displayName, results } = matchDayUpdate;
      const updateData = { displayName: 'pokeeffe', results };
      const refString = rtPath_results(realtimeDocumentType, pathViews, sportsYear, matchKey, uid ? uid : 'gs');
      if (allowUpdate && useRtMatchData) {
        return updateDatabase(refString, updateData).then(result => ({ ...result, matchKey }));
      } else {
        console.log('updateRealtimeScoreToDatabase not permitted', sportDataSettings, refString, updateData);
        return { success: false, matchKey, error: 'Update not permitted' };
      }
    });

    // Wait for all updates to complete
    const results = await Promise.all(updatePromises);
    callback && callback(results);

  } else {
    // Handle single update if no `matchDayUpdates`
    const refString = rtPath_results(realtimeDocumentType, pathViews, sportsYear, match_key, uid ? uid : currentUserId);
    const updateData = { displayName: displayName ? displayName : 'public', results, ...(tracker && { tracker }) };

    if (allowUpdate && useRtMatchData) {
      const result = await updateDatabase(refString, updateData);
      callback && callback(result);
    } else {
      console.log('updateRealtimeScoreToDatabase not permitted', sportDataSettings, refString, updateData);
    }
  }
};

const updateMatchDayScoresToDatabase = async (mainRt, rtProps) => {
  const {
    sportDataSettings,
    pathViews,
    match_key,
    results,
    appUserInfo,
    latestSeason,
    tracker,
    callback
  } = rtProps;

  // fe21069b-9b7b-4779-8ac1-547bdb135d5c

  const allowUpdate = true // sportPermissions.any && sportPermissions[seasonalUpdateType] && _allowRt; 
  const { uid, displayName } = appUserInfo ?? {};
  const sportsYear = getSportsYear(latestSeason);

  // Helper function to update database and handle success/failure
  const updateDatabase = async (refString, updateData) => {
    try {
      console.log('updateRealtimeScoresToDatabase!!!!', refString, updateData);
      await set(ref(mainRt, refString), updateData);
      return { success: true };
    } catch (error) {
      console.log('updateRealtimeScoreToDatabase Error', error);
      return { success: false, error };
    }
  };

  // Handle single update if no `matchDayUpdates`
  const refString = rtPath_results(realtimeDocumentTypes.matchDay, pathViews, sportsYear, match_key, uid);
  const updateData = { displayName, results, ...(tracker && { tracker }) };
  if (allowUpdate) {
    // const result = await updateDatabase(refString, updateData);
    callback && callback({ result });
  } else {
    console.log('updateRealtimeScoreToDatabase not permitted', sportDataSettings, refString, updateData);
  }
};


/**
 * Gets the scores from the realtime database
 * @param {object} pathViews 
 * @param {string} latestSeason 
 * @param {function} callback 
 */
const getRealtimeScores = async (mainRt, realtimeDocumentType, useRtMatchData, pathViews, latestSeason, callback) => {

  const sportsYear = getSportsYear(latestSeason)
  const refString = rtPath_results(realtimeDocumentType, pathViews, sportsYear)

  const _ref = ref(mainRt, refString);

  if (useRtMatchData) {
    onValue(_ref, (snapshot) => {
      callback(snapshot.val())
    });
  }

}

/**
 * Updates the scores into the realtime database
 * @param {object} pathViews 
 * @param {object} realtimeMatch 
 * @param {object} results 
 * @param {object} appUserInfo 
 * @param {string} latestSeason 
 * @param {function} callback 
 */
const deleteRealtimeDatabaseScores = async (mainRt, realtimeDocumentType, sportPermissions, sportDataSettings, seasonalUpdateType, pathViews, _matchKeys, appUserInfo, latestSeason, callback) => {

  const allowUpdate = _allowUpdate_local && sportPermissions?.any && sportPermissions?.[seasonalUpdateType] && _allowRt
  const { useRtMatchData } = sportDataSettings ?? {}

  const { uid } = appUserInfo ?? {}
  const sportsYear = getSportsYear(latestSeason)

  const promises = _.map(_matchKeys, async (matchKey) => {
    const refString = uid ? rtPath_results(realtimeDocumentType, pathViews, sportsYear, matchKey, uid) : rtPath_results_noId(realtimeDocumentType, pathViews, sportsYear, matchKey);
    if (allowUpdate && useRtMatchData) {
      try {
        await set(ref(mainRt, refString), null);
        if (callback) {
          callback({ success: true })
        }
        return { success: true };
      } catch (error) {
        return { success: false, error };
      }
    } else {
      console.log('-----------')
      console.log('deleteRealtimeDatabaseScores')
      console.log('allowUpdate', allowUpdate, seasonalUpdateType)
      console.log('refString', refString);
      if (callback) {
        callback({ success: true })
      }
      return { success: true };
    }
  });

  const results = await Promise.all(promises);

  const success = results.every(result => result.success);
  callback && callback({ success, results });
}

const ammendRealtimeResults = (rtr, gameScoringType) => {
  if (rtr) {
    _.forEach(rtr, (rtMatch) => {
      _.forEach(rtMatch, (rtUserMatch) => {
        const { results } = rtUserMatch ?? {}
        const { scores } = results ?? {}
        if (scores && _.isArray(scores)) {
          results.scores = convertHelpers.createObjectFromArray(scores)
        }
      })
    })
  }
}

/**
 * 
 * @param {boolean} useRtMatchData 
 * @param {object} match 
 * @param {object} match_true 
 * @param {object} pathViews 
 * @param {object} appUserInfo 
 * @param {number} latestSeason 
 * @description calculates the match and updates the realtime database
 */
const calcMatchAndUpdateRtDb = (mainRt, sportPermissions, sportDataSettings, match, match_true, pathViews, appUserInfo, latestSeason, tracker) => {
  matchCalcs.calcVballMatch(match)
  const { useRtMatchData } = sportDataSettings ?? {}
  const current_props = { match_rt: match.results, match_true }
  if (useRtMatchData) {
    updateCurrentRealtimeMatchScoreToRtDb(mainRt, sportPermissions, sportDataSettings, pathViews, current_props, appUserInfo, latestSeason, tracker)
  } else {
    console.log('calcAndUpdate not permitted', useRtMatchData, current_props)
  }
}

const updateCurrentRealtimeMatchScoreToRtDb = async (mainRt, sportPermissions, sportDataSettings, pathViews, actionProps, appUserInfo, latestSeason, tracker, callback) => {

  const { useRtMatchData } = sportDataSettings ?? {}
  const { match_rt, match_true } = actionProps ?? {}
  const { score, scores, complete, winner, loser, setNumber, setScorez } = match_rt ?? {}
  const { _itemKey: match_key } = match_true ?? {}

  if (match_rt && match_key && (score || scores)) {

    const res = {}
    if (complete) { res.complete = true; }
    if (scores) { res.scores = scores; }
    if (score) { res.score = score; }
    if (winner) { res.winner = winner; }
    if (loser) { res.loser = loser; }
    if (setNumber) { res.setNumber = setNumber; }
    if (useRtMatchData) {
      const rtProps = {
        realtimeDocumentType: realtimeDocumentTypes.realtime,
        sportPermissions,
        sportDataSettings,
        seasonalUpdateType: seasonalUpdateTypes.matches,
        pathViews,
        match_key,
        results: res,
        appUserInfo,
        latestSeason,
        tracker,
        callback
      }
      updateRealtimeScoresToDatabase(mainRt, rtProps)
    } else {
      console.log('updateCurrentRealtimeMatchScore not permitted', sportDataSettings, res)
    }
  }
}
